<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import store from "./store";
import chatApi from "./components/methods";
import Storage from './api/storage'
export default {
  name: 'App',
  created() {
    let loading = this.$loading({})
    chatApi.initData(loading);
  },
  methods:{

  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
}
html,body{
  width:100%;
  height:100%;
  margin: 0;
  padding: 0;
  border:none;
}
.el-drawer.ttb{
  background: transparent;
}
div, h1, img, p, ul {
  list-style: none;
  padding: 0;
  margin: 0;
  -webkit-user-drag: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue